var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "link",
      attrs: { href: "javascript:;" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.scheduler($event)
        }
      }
    },
    [
      _vm._t("label", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__("Gérer les modèles de pages de planification")
            ) +
            "\n    "
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }